<template>
	<div class="content">
		<div class="content_head">
			<select v-model="areaID" v-if="$store.state.user.UserType==0" @change="selectArea">
				<option v-for="(i,index) in $store.state.area" :value="i.areaID">{{i.areaName}}</option>
			</select>

			<select v-model="ShopID" title="选择店铺" @change="pageIndex=1; getData()"
				v-if="$store.state.user.UserType<=1 && $store.state.user.ShopType<=1">
				<option v-for="i in Shop" :value="i.ShopID">
					{{i.ShopName}}
				</option>
			</select>

			<input type="text" style="width:15rem;" @keypress.enter="pageIndex=1;getData()" v-model="searchText"
				class="search" placeholder="书籍名称|书籍编码" />
			<button type="button" class="button " @click="pageIndex=1; getData()">查找</button>
		</div>
		<div class="content_body">
			<table>
				<thead>
					<tr>
						<th>序号</th>
						<th>客户姓名</th>
						<th>手机号</th>
						<th>书籍名称</th>
						<th>书籍编号</th>
						<th>借出时间</th>
						<th>借出店铺</th>
						<th>操作人</th>
						<th>订单详情</th>
					</tr>
				</thead>
				<tbody>

					<tr v-for="(i,index) in books">
						<td class="center">
							{{index+1+ (pageIndex-1)*pageRows}}
						</td>
						<td>{{i.CustomerName}}</td>
						<td>{{i.CustomerPhone}}</td>
						<td>{{i.BooksName}}</td>
						<td>{{i.BooksNumCode}}</td>

						<td> {{$moment (i.BorrowDate).format('YYYY年MM月DD日')}}-<span class="red">
								{{ ($moment(new Date()).diff($moment(i.BorrowDate), 'days')+1) +'天'    }}
							</span> </td>
						<td>{{i.ShopName}}</td>
						<td>{{i.UserName}}</td>
						<td><button class="button" @click="$router.replace('/queryDay/orderDetail/'+i.CustomerOrderID)"
								type="button">订单详情</button></td>
					</tr>

				</tbody>
			</table>
		</div>
		<div class="foot_pages">
			未归还书籍:
			<span class="red">{{ count +'本'}}</span>


			<button class="button" :class="{'disabled':up}" :disabled="up" @click="changePages('up')">上一页</button>
			<span>{{page}}</span>

			<select v-model="pageRows" @change="changePageRows">
				<option value="5">5/页</option>
				<option value="10">10/页</option>
				<option value="15">15/页</option>

			</select>
			<button class="button" :class="{'disabled':down}" :disabled="down" @click="changePages('down')">下一页</button>
			 
		</div>

	</div>

</template>

<script>
	import j from './queryDay.js'
	export default j
</script>

<style>

</style>
